import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let submit = useDataSubmit({
    context: 'task',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    if (value) {
      submit({
        type: 'set_task_priority',
        task_id: id,
        priority: value,
      })
    }
  }
}
